export const metricHistoryEmptyCopy = ({ metricState, supportsHistory } = {}) => {
  if (supportsHistory === false) {
    return {
      title: 'Historical metrics unsupported',
      detail: 'This provider does not supply historical telemetry for this resource.',
    };
  }
  if (metricState === 'error') {
    return {
      title: 'Metrics unavailable',
      detail: 'Cloud Watcher could not load provider telemetry. No values are being estimated.',
    };
  }
  if (metricState === 'unavailable') {
    return {
      title: 'Live metrics unavailable',
      detail: 'The provider did not return telemetry for this resource. No values are being estimated.',
    };
  }
  if (metricState === 'loading') {
    return {
      title: 'Loading provider metrics…',
      detail: 'Waiting for the first provider response.',
    };
  }
  return {
    title: 'No recorded metrics yet',
    detail: 'Telemetry is available, but no historical samples have been recorded for this period.',
  };
};
